import React from 'react';
import { useSelector } from 'react-redux';

import { makeStyles } from 'tss-react/mui';

import { Grid } from '@hbf/dsl';
import { useMediaQuery } from 'ha/helpers/MediaQuery';

import { SearchLocationTitle } from './SearchLocationTitle';
import { SearchAdvertiserLink } from './SearchAdvertiserLink';
import { getIsAdvertiserSearch } from '../selectors';

const useStyles = makeStyles()(theme => ({
  ellipsis: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  locationTitle: {
    marginTop: theme.spacing(1.8),
    marginBottom: theme.spacing(1.8),
    marginRight: theme.spacing(1),
  },
}));

export const SearchResultsInfoBar: React.FC = () => {
  const { md } = useMediaQuery();
  const isAdvertiserSearch = useSelector(getIsAdvertiserSearch);
  const { classes, cx } = useStyles();

  return (
    <Grid container justifyContent="space-between" alignItems="center">
      <Grid item zeroMinWidth xs={12}>
        <SearchLocationTitle
          className={cx(classes.locationTitle, md && classes.ellipsis)}
        />
      </Grid>
      {isAdvertiserSearch && (
        <Grid item xs={12}>
          <SearchAdvertiserLink />
        </Grid>
      )}
    </Grid>
  );
};
